import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Orders'*/ 'src/controllers/Orders/Orders'),
	loading: Loading,
});
